// https://stackoverflow.com/a/60132060
// Make sure that the statuses listed here are exactly the same as the types
const arrayOfAll = () => (array) => array;
const arrayOfAllStatuses = arrayOfAll();
export const STATUSES = arrayOfAllStatuses([
    'Submitted',
    'Request canceled',
    'Accepted',
    'In progress',
    'Completed',
    'Verified',
    'On hold',
    'Wontfix',
    'Work not accepted',
]);
